<template>
  <div class="home-product">
    <div class="container">
    <div class="home-product-title">产品列表</div>
      <div class="home-product-line"></div>

      <div class="home-product-list">
        <div class="home-product-border" @click="toPWmatIntroduce">
          <div>
            <img class="home-product-img" src="../../assets/home/product_1.png">
            <div class="home-product-name">PWmat</div>
          </div>

         <!--<div class="home-product-desc">PWmat是原子尺度方面的材料模拟软件包，基于GPU架构，利用平面波基组、赝势方法进行电子结构计算、分子动力学模拟。</div>-->
        </div>


        <div class="home-product-border" @click="toMLFFIntroduce">
          <img class="home-product-img" src="../../assets/home/pwmat-mlff.jpg">
          <div class="home-product-name">PWMLFF</div>
<!--          <div class="home-product-desc">预装PWmat软件的单台GPU服务器，其计算能力与96核CPU相当，可以计算4000电子以内的体系的电子结构，具有节能、低发热、无需机房等优点，特别适合小型计算课题组或者实验组。</div>-->
        </div>

<!--       <div class="home-product-border" @click="toDMSTATIONIntroduce">
          <img class="home-product-img" src="../../assets/home/product_3.png">
          <div class="home-product-name">双机互联版Mstation</div>  
          <div class="home-product-desc">通过infiniband线互联的预装PWmat软件的两台GPU服务器，可以计算1800原子以内或者7200电子以内的体系，是一种高性价比的计算集群方案，无需采购价格昂贵的infiniband交换机，计算规模比单台GPU服务器显著提升。</div>
        </div>-->

        <div class="home-product-border" @click="toPWMGUIIntroduce">
          <img class="home-product-img" src="../../assets/home/q-flow.jpg">
          <div class="home-product-name">Q-Flow</div>
<!--          <div class="home-product-desc">PWmat软件与标准的高性能计算集群方案双剑合璧，配备infiniband交换机以及专业集中存储，支持上千块GPU卡的并行计算，能够完成几千原子体系的电子结构计算。在并行效率上，20节点以内，性能根据节点数能够达到线性增长。</div>-->
        </div>

        <div class="home-product-border" @click="toQStudioIntroduce">
          <img class="home-product-img" src="../../assets/home/q-studio.png">
          <div class="home-product-name">Q-Studio</div>
        </div>

        <div class="home-product-border" @click="toIntegration">
          <img class="home-product-img" src="../../assets/home/product_2.jpg">
          <div class="home-product-name">一体机Mstation</div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'HelloWorld',
  props: {

  },
  components: {

  },
  methods:{
    toPWmatIntroduce(){
      this.$router.push({ name: 'PWmatIntroduce'})
    },
    toMSTATIONIntroduce(){
      this.$router.push({ name: 'MSTATIONIntroduce'})
    },
    toDMSTATIONIntroduce(){
      this.$router.push({ name: 'DMSTATIONIntroduce'})
    },
    toMCLUSTERIntroduce(){
      this.$router.push({ name: 'MCLUSTERIntroduce'})
    },
    toMcloudIntroduce(){
      this.$router.push({ name: 'McloudIntroduce'})
    },
    toMLFFIntroduce(){
      this.$router.push({ name: 'MLFFIntroduce'})
    },
    toIntegration(){
      this.$router.push({ name: 'Integration'})
    },
    toQStudioIntroduce(){
      this.$router.push({ name: 'QStudioIntroduce'})
    },
    toPWMGUIIntroduce(){
      this.$router.push({ name: 'PWMGUIIntroduce'})
    },


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-product-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .home-product{
    margin-top: 60px;
  }
  .home-product-title{
    font-size:32px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(73,145,201,1);
    line-height:45px;
  }
  .home-product-line{
    height:1px;
    margin-top: 8px;
    background:rgba(240,240,240,1);
  }
  .home-product-list{
    margin: 10px -15px 0 -15px;
  }
  .home-product-border{
    width: 218px;
    margin: 30px 5px 0px 5px;
    display: inline-block;
    cursor: pointer;
    padding-bottom: 25px;
    border: 1px solid rgba(240,240,240,1);
    vertical-align: top;
    
    
  }
  .home-product-border:hover{
    border: 1px solid rgba(73,145,201,1);
  }
  .home-product-img{
    width: 216px;
  }
  .home-product-name{
    margin-top: 20px;
    font-size:18px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(73,145,201,1);
    line-height:33px;
    text-align: center;
  }
  .home-product-desc{
    margin: 28px 16px 0 16px;
    font-size:14px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:29px;
  }
  @media (max-width: 576px) {
    .home-product-list{
      text-align: center;
    }
  }

  @media (min-width: 576px) and (max-width:768px) {
    .home-product-list{
      text-align: center;
    }
  }

  @media (min-width: 768px) and (max-width:992px) {
    .home-product-list {
      text-align: center;
    }
  }

  @media (min-width: 1200px) and (max-width:992px){
    .home-product-border {
      width: 182px;
      margin: 30px 5px 0 5px;
    }
    .home-product-img{
      width: 180px;
    }
  }

  @media (min-width: 1200px) {

  }
</style>
